import {
  Card,
  Logo,
  InlineExternalLink,
  Tag,
  fontStyles as fs,
} from '@monash/portal-react';
import c from './update-card.module.scss';
import { getDueText } from '../utils/get-due-text';
import { formatPublishDate } from '@/components/utilities/format-publish-date';
import classNames from 'classnames';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';

const UpdateCard = ({
  title,
  description,
  links,
  isDueSoon,
  isNew,
  dueDate,
  currentDate,
  publishDate,
  ...restProps
}) => {
  const tagColor = isDueSoon ? 'orange' : 'grey';
  const publishDateFormatted = formatPublishDate(currentDate, publishDate);

  const editor = useEditor({
    editable: false,
    extensions: [
      StarterKit,
      Document,
      TaskList,
      TaskItem.configure({
        nested: false,
      }),
    ],
    content: description,
  });

  return (
    <Card
      tabIndex={0}
      {...restProps}
      className={isNew && 'new-updates-card'}
      data-tracking-event={`updates-${title}`}
    >
      <div className={c.topSection}>
        <div className={c.header} aria-label="By Monash University.">
          <div className={c.logoWrapper}>
            <Logo.Shield height={24} aria-hidden />
          </div>
          <div>
            <div className={fs.label}>Monash University</div>
            <div className={classNames(fs.label, c.publishDate)}>
              {publishDateFormatted}
            </div>
          </div>
        </div>

        <div className={c.tags}>
          {isNew && <Tag text="New!" color="blue" />}
          {dueDate && <Tag text={getDueText({ dueDate })} color={tagColor} />}
        </div>
      </div>

      <h3 className={classNames(c.title, fs.heading, fs.md)}>{title}</h3>

      <div className={c.description}>
        <EditorContent editor={editor} />
      </div>

      {links?.map(({ label, url }) => {
        const textLabel = label || url;

        return (
          textLabel && (
            <InlineExternalLink
              link={url}
              text={textLabel}
              className={c.link}
              key={`${label}-${url}`}
              data-tracking-event={`updates-${title}-${textLabel}`}
              data-tracking-event-location="updates-card"
            />
          )
        );
      })}
    </Card>
  );
};

export default UpdateCard;
